import {createStyles, Theme} from "@material-ui/core";
import {styleColors, typography} from "src/main.style";

export const CheckboxButtonStyle = (theme: Theme) => createStyles({
    root: {
        display: 'flex',
        flexDirection: 'row',
        gap: theme.spacing(1),
        backgroundColor: theme.palette.common.white,
        border: '2px solid',
        outline: 'none',
        borderColor: theme.palette.common.black,
        borderRadius: '0.4375rem',
        minHeight: '55px',
        alignItems: 'center',
        justifyContent: 'space-between',
        padding: theme.spacing(2, 2.75),
    },
    label: {
        ...typography.button,
        color: theme.palette.common.black,
    },
    checkbox: {
        appearance: 'none',
        outline: 'none',
        border: 'none',
        margin: 0,
        background: styleColors.transparent,
        boxSizing: 'content-box',
    },
    checkedCheckbox: {
        backgroundColor: theme.palette.primary.light,
    },
    focusedCheckbox: {
        outline: '1px solid',
        outlineColor: theme.palette.common.black,
        borderColor: theme.palette.common.black,
    },
    invalidCheckbox: {
        outline: '1px solid',
        outlineColor: theme.palette.error.main,
        borderColor: theme.palette.error.main,
    },
});



// WEBPACK FOOTER //
// ./src/components/common/checkboxButton/checkboxButton.style.ts